import _ from 'lodash';
import { gql } from '@apollo/client';
import { Mutation } from '@apollo/client/react/components';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';

import {
  Column,
  Container,
  Data,
  Grid,
  Header,
  NoDataMessage,
  Row,
  ExipireButton,
  HeaderRow,
} from './styles';

import {
  ClickableData,
} from '../../styles';

const FORCE_EXPIRE = gql`
  mutation ExpireTestSession($projectId: ID!) {
    expireTestSessions(projectId: $projectId) {
      testSessions {
        id
      }
    }
  }
`;

const PendingTesters = ({
  testers, projectId, onSetCurrentTester, refetch,
}) => (
  <Container>
    <Grid column={3}>
      <HeaderRow>
        <Column verticalAlign="middle" width={3}>
          <Header>Tester</Header>
        </Column>

        <Column verticalAlign="middle" width={9}>
          <Header>Expires On</Header>
        </Column>
        <Column width={4}>
          {!_.isEmpty(testers) && (
            <Mutation
              mutation={FORCE_EXPIRE}
              update={(cache) => {
                cache.evict({ fieldName: 'testers', args: { projectId, isPending: true } });
              }}
              onCompleted={refetch}
            >
              {(expireTestSessions, { loading }) => (
                <ExipireButton
                  loading={loading}
                  onClick={() => {
                    expireTestSessions({
                      variables: { projectId: _.first(testers).project.id },
                    });
                  }}
                >
                  Expire All
                </ExipireButton>
              )}
            </Mutation>
          )}
        </Column>
      </HeaderRow>

      {_.isEmpty(testers)
        && <NoDataMessage>No pending testers found</NoDataMessage>}

      {!_.isEmpty(testers) && testers.map((tester) => {
        const testSession = _.first(tester.testSessions);

        if (!testSession) {
          return null;
        }

        return (
          <Row key={tester.id}>
            <Column width={3}>
              <ClickableData onClick={() => onSetCurrentTester(tester)}>
                {tester.user.profile.firstName}
                {' '}
                {tester.user.profile.lastName}
              </ClickableData>
            </Column>

            <Column width={3}>
              <Data>
                {testSession.expiresAt && moment(testSession.expiresAt).format('MM/DD/YYYY hh:mm A')}
              </Data>
            </Column>
          </Row>
        );
      })}
    </Grid>
  </Container>
);

PendingTesters.propTypes = {
  testers: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.object]),
  ).isRequired,
  projectId: PropTypes.string.isRequired,
  onSetCurrentTester: PropTypes.func.isRequired,
  refetch: PropTypes.func.isRequired,
};

export default PendingTesters;
